import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';

type SmartCareResponse = {
  isAvailable: boolean;
  url: string
}

export default class SmartCareService {

  public static isAvailable(): Promise<SmartCareResponse> {
    return HttpService
      .get(Endpoint.GET_SMART_CARE_IS_AVAILABLE, {}, {})
      .then(r => r.body as SmartCareResponse);
  }
}